//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import date from '@/utils/date'
export default {
    data() {
        return {
            info: {},
            img: ''
        }
    },
    created() {
        if (!this.appointment) this.getOrderInfo()
        else{
            this.img = require(`@/assets/images/pc/appointment_success.png`)
        }    
    },
    computed: {
        appointment() {
            return this.$route.query.type === 'appointment'
        },
        title() {
            let title = '';
            if(this.info.orderStatus == 2 || this.info.orderStatus == 3 || this.info.orderStatus == 7) {
                title = '多謝選購我們的服務，服務合約副本將會於一小時內發送至您的電郵地址。'
            }else title = '帶機上台'
            if (this.appointment) title = '感謝閣下登記中國移動月費服務計劃，我們的客戶主任將會盡快與您聯絡，處理閣下之申請'
            return title
        }
    },
    methods: {
        date,
        toView() {
            this.$router.push({
                name: 'confirm',
                query: {
                    id: this.info.id || this.info.businessOrderId,
                    packageType: this.info.businessType || this.info.purchaseType
                }
            })
        },
        getOrderInfo() {
            let { orderId, info } = this.$route.query
            if(info) {
                this.info = JSON.parse(info)
                this.img = require(`@/assets/images/pc/orderStatus_${this.info.orderStatus}.png`)
                return
            }
            return this.$http('order/getOrderInfo', {mainOrderId: orderId}).then(res=>{
                if(res.returnCode == 1000) {
                    this.info = res.dataInfo
                    let _img;
                    if(this.$route.params.status == 'info') _img = this.info.orderStatus
                    else _img = (this.$route.params.status == 'success' ? '4' : '1')
                    this.img = require(`@/assets/images/pc/orderStatus_${_img}.png`)
                    let userType = res.dataInfo.userType

                    if (this.addTrackfilter(userType)) {
                        //TODO:xiao
                        let pid = '18427' //測試號碼，上線要改
                        let refId = res.dataInfo.orderRef
                        let amount = res.dataInfo.monthsFee / 100
                        let element = document.createElement('img')
                        const lhref = window.location.href
                        let isDebug = lhref.includes('devcloud') || lhref.includes('192.168') || lhref.includes('localhost')
                        //生产的
                        let src = `https://www.chinesean.com/affiliate/tracking.do?pId=${pid}&tracking=${refId}&cpa=&cpl=&cps=${amount},TIERID`
                        if (isDebug) {
                            //测试的
                            src = `http://www.chinesean.com/affiliate/clickBanner.do?wId=10061&cId=33766&pId=${pid}&tracking=${refId}&cpa=&cpl=&cps=${amount},TIERID`
                            src = `https://www.chinesean.com/affiliate/tracking.do?pId=18427&cpa=&cpl=&tracking=${refId}&cps=${amount},TIERID`
                        }
                        element.src = src
                        element.width = 1
                        element.height = 1
                        document.getElementsByTagName('body')[0].appendChild(element)    
                    }
                }
            })
        },
        //本地判斷，是否添加需要統計代碼的用戶類型過濾  Affiliate
        addTrackfilter(type) {
            const lhref = window.location.href
            let isDebug = lhref.includes('devcloud') || lhref.includes('192.168') || lhref.includes('localhost')
            let filterList = []
            if (isDebug) {
                //测试环境过滤
                // filterList = {'89': true} 2020年4月10日17:42:39 后台说89
                filterList = {'80': true, '89': true} //测试要80
            } else {
                //生产环境过滤
                filterList = {'78': true}
            }
            let result = filterList[type]
            return result
        }
    }
}
